import { initialValuesOriginChannel as initialValues } from '../../../../../../../helpers/variablesInitialValues';
import * as types from '../types/originChannelType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const originChannelReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_ORIGIN_CHANNEL:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_ORIGIN_CHANNEL:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_ORIGIN_CHANNEL:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_ORIGIN_CHANNEL:
			return {
				...state,
				search: payload
			};
		
		case types.ARRAY_LIST_ORIGIN_CHANNEL:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_ORIGIN_CHANNEL:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_ORIGIN_CHANNEL:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_ORIGIN_CHANNEL:
			return {
				...state,
				isOpenModal: payload
			};
		
		case types.IS_LOADING_SHOW_ORIGIN_CHANNEL:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_ORIGIN_CHANNEL:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_ORIGIN_CHANNEL:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_ORIGIN_CHANNEL:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default originChannelReducer;
